import React, { useEffect, useContext } from 'react';
import { Row, Col } from 'react-bootstrap';
import dictData from 'dictionary';
import { MatchMediaContext } from 'context/MatchMediaContext';
import HomeSectionHeader from 'components/pages/home/HomeSectionHeader';
import { AnimationHomeItSzkola } from 'components/pages/home/animations';
import { ReactComponent as LogoItSzkola } from 'images/icons/ose-itszkola.svg';
import PointingPath from 'images/icons/PointingPath';
import LaptopItSzkola from 'images/laptop-itszkola.png';
import routeList from 'routes/routeList';

const HomeItSzkola: React.FC = () => {
  const { isLg } = useContext(MatchMediaContext);
  useEffect(AnimationHomeItSzkola, []);

  return (
    <section className="home-it-szkola-wrapper">
      <div className="content-wrapper">
        <HomeSectionHeader
          subtitle={dictData.home.itSzkolaPresentation.subtitle}
          title={dictData.home.itSzkolaPresentation.title}
          description={dictData.home.itSzkolaPresentation.description}
          linkTo={routeList.itszkolaRecommend}
          secondaryButtonStyle
        />
        <div className="home-it-szkola-presentation">
          <Row className="w-100">
            <Col md={5} className="home-it-szkola-logo-wrapper">
              <LogoItSzkola className="home-it-szkola-logo" />
            </Col>
            <Col md={7}>
              <div className="home-it-szkola-device">
                <div className="home-it-szkola-device-circle" />
                {isLg && (
                  <div className="home-it-szkola-device-top-pointer">
                    <PointingPath className="home-it-szkola-device-path-top" />
                  </div>
                )}
                <img data-src={LaptopItSzkola} alt="" className="lazyload" />
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div className="home-it-szkola-learn-container">
        <div className="home-it-szkola-learn-wrapper">
          <div className="home-it-szkola-learn-background-container">
            <div className="home-it-szkola-learn-background" />
          </div>
          <div className="home-it-szkola-content content-wrapper">
            {isLg && (
              <div className="home-it-szkola-device-bottom-pointer">
                <PointingPath className="home-it-szkola-device-path-bottom" />
              </div>
            )}
            <HomeSectionHeader
              subtitle={dictData.home.itSzkolaPresentation.subtitle}
              title={dictData.home.itSzkolaLearn.title}
              description={dictData.home.itSzkolaLearn.description}
              secondaryButtonStyle
              ctaHref={routeList.itSzkola}
              ctaButtonText={dictData.home.itSzkolaLearn.ctaButtonText}
              className="home-it-szkola-learn-header"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeItSzkola;
